module.exports = __webpack_public_path__ + "static/media/GearShiftAssyWithCable.35a000ff.png";